import { ArsContextState, IArsActionSetVariablesInUse } from "../interface";

/**
 * Stores variables in use and derives datasets in use.
 *
 * @param state - Current ARS context state
 * @param action - Set-variables-in-use action
 * @returns Updated state with variable usage metadata
 */
export const arsc_setVariablesInUse = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetVariablesInUse,
): ArsContextState<T> => {
  const datasetsInUse = new Set<string>(
    Array.from(action.variablesInUse).flatMap((varName) => varName.split(".")[0]),
  );

  return {
    ...state,
    datasetsInUse,
    variablesInUse: action.variablesInUse,
  };
};
